module.exports = __webpack_public_path__ + "static/img/07@2x.e97cc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/07@2x.png
// module id = dJWV
// module chunks = 1